module.exports = __webpack_public_path__ + "static/media/notes.cba9d696.svg";